const Size = class {
  static isMultiWord = size => size.includes(' ');

  static getSizeStrings = size => {
    if (Size.isMultiWord(size)) {
      return [size.substr(0, size.indexOf(' ')), size.substr(size.indexOf(' ') + 1)];
    }
    return null;
  };

  static hasParenthetical = size => {
    const sizeStrings = Size.getSizeStrings(size);
    if (!sizeStrings) {
      return false;
    }
    return sizeStrings[1].startsWith('(') && sizeStrings[1].endsWith(')');
  };

  static hasSlash = size => size.includes('/');

  static isSizeButtonSquare = size => {
    if (Size.hasParenthetical(size) || Size.hasSlash(size)) {
      return false;
    }
    return true;
  };

  /**
   * Converts a decimal number to a fractional string using standard fractions.
   * @param {number} decimal - The decimal number to convert.
   * @param {number} precision - The denominator for rounding (e.g., 8 for eighths).
   * @returns {string} The fractional representation using standard fraction notation.
   */
  static decimalToFraction = (decimal, precision = 8) => {
    const wholeNumber = Math.floor(decimal);
    let fractionalPart = decimal - wholeNumber;

    // Calculate the numerator based on precision
    let numerator = Math.round(fractionalPart * precision);
    let denominator = precision;

    // Handle cases where numerator equals denominator
    if (numerator === denominator) {
      return `${wholeNumber + 1}`;
    }

    // Simplify the fraction
    const gcd = (a, b) => (b === 0 ? a : gcd(b, a % b));
    const divisor = gcd(numerator, denominator);
    numerator /= divisor;
    denominator /= divisor;

    if (numerator === 0) {
      return `${wholeNumber}`;
    }

    const fractionString = `${numerator}/${denominator}`;

    return wholeNumber > 0 ? `${wholeNumber} ${fractionString.trim()}` : fractionString;
  };
};

export default Size;
